/** Zustand devtools `name` — single source of truth for stores under `src/common`. */
export const StoreDevtoolsName = {
  BaseStore: 'BaseStore',
  Activityfeed: 'ActivityfeedStore',
  AccountSettings: 'AccountSettingsStore',
  AppInit: 'AppInitStore',
  ArtifactFeeds: 'ArtifactFeedsStore',
  Gateways: 'GatewaysStore',
  GatewayListMobileFilters: 'GatewayListMobileFiltersStore',
  Layout: 'LayoutStore',
  Memberships: 'MembershipsStore',
  Notifications: 'NotificationsStore',
  Onboarding: 'OnboardingStore',
  OrganizationsSettings: 'OrganizationsSettingsStore',
  GraftcodeOnboarding: 'GraftcodeOnboardingStore',
  PortalOnboarding: 'PortalOnboardingStore',
  ProjectKeys: 'ProjectKeysStore',
  Projects: 'ProjectsStore',
  ServiceMap: 'ServiceMapStore',
  Session: 'SessionStore',
  Toast: 'ToastStore',
  User: 'UserStore',
  WorkspaceSettings: 'WorkspaceSettingsStore',
  Workspaces: 'WorkspacesStore',
} as const

export type StoreDevtoolsName = (typeof StoreDevtoolsName)[keyof typeof StoreDevtoolsName]
